interface Props {
  small?: boolean;
  white?: boolean;
  clicable?: boolean;
}
const SvgComment: React.FC<Props> = ({ small, white, clicable }) => {
  return (
    <svg
      style={{
        transform: small ? "scale(0.67)" : "",
        cursor: clicable ? "pointer" : "default",
        color: white ? "var(--on-accent)" : undefined,
      }}
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon">
        <path
          id="Vector"
          d="M4.27075 2.25C2.93128 2.25 1.83325 3.34802 1.83325 4.6875V10.6875V12.9507C1.83325 13.6825 2.72947 14.1394 3.32153 13.7095C3.32178 13.7095 3.32202 13.7095 3.32227 13.7095L4.94238 12.531C5.25136 13.5231 6.18113 14.25 7.27075 14.25H11.9626L15.3442 16.7095C15.3445 16.7095 15.3447 16.7095 15.345 16.7095C15.937 17.1394 16.8333 16.6825 16.8333 15.9507V13.6875V7.6875C16.8333 6.34802 15.7352 5.25 14.3958 5.25H13.8333V4.6875C13.8333 3.34802 12.7352 2.25 11.3958 2.25H4.27075ZM4.27075 3.375H11.3958C12.127 3.375 12.7083 3.95623 12.7083 4.6875V8.8125C12.7083 9.54377 12.127 10.125 11.3958 10.125H6.52075C6.40179 10.125 6.28589 10.1627 6.1897 10.2327L2.95825 12.583V10.6875V4.6875C2.95825 3.95623 3.53948 3.375 4.27075 3.375ZM13.8333 6.375H14.3958C15.127 6.375 15.7083 6.95623 15.7083 7.6875V13.6875V15.583L12.4768 13.2327C12.3806 13.1627 12.2647 13.125 12.1458 13.125H7.27075C6.53948 13.125 5.95825 12.5438 5.95825 11.8125V11.792L6.70386 11.25H11.3958C12.7352 11.25 13.8333 10.152 13.8333 8.8125V6.375Z"
          className={`${white ? "fill-current" : "fill-primary"}`}
        />
      </g>
    </svg>
  );
};

export default SvgComment;
